import { Routes } from '@angular/router';
import { RouterModule } from '@angular/router';
import {NgModule} from '@angular/core';
import {PortalService} from '../services/portal.service';
import {AdvisorPagenotfoundComponent} from "../advisor.pagenotfound.component";
import {StepChapterComponent} from "../step/step.chapter.component";
import {EingabeStartComponent} from "./eingabe/eingabe.start.component";
import {EingabeStepComponent} from "./eingabe/eingabe.step.component";
import {EingabeAusstiegComponent} from "./eingabe/eingabe.ausstieg.component";
import {ErgebnisComponent} from "./ergebnis/ergebnis.component";
import {EingabeShowerDataComponent} from "./eingabe/eingabe.shower-data.component";

/**
 * Routes for the warmwassercheck.
 * The default route leads to warmwassercheck here
 */
const routes: Routes = [
  { path: ':portalId/warmwassercheck', children: [
    // default step 'eingabe'
    {path: '', redirectTo: 'start', pathMatch: 'full'},

    {path: 'start', component: EingabeStartComponent},

    // input section
    {path: 'eingabe', component: StepChapterComponent, children: [
      {path: 'basisdaten/1', component: EingabeStepComponent, data: {swipeCount: '2'}},
      {path: 'basisdaten/2', component: EingabeStepComponent, data: {swipeCount: '3'}},
      {path: 'basisdaten/3', component: EingabeStepComponent, data: {swipeCount: '4'}},
      {path: 'basisdaten/4', component: EingabeStepComponent, data: {swipeCount: '5'}},

      {path: 'verbrauchsdaten/1', component: EingabeStepComponent, data: {swipeCount: '10'}},
      {path: 'verbrauchsdaten/2', component: EingabeStepComponent, data: {swipeCount: '11'}},
      {path: 'verbrauchsdaten/3', component: EingabeStepComponent, data: {swipeCount: '12'}},
      {path: 'verbrauchsdaten/4', component: EingabeStepComponent, data: {swipeCount: '13'}},
      {path: 'verbrauchsdaten/5', component: EingabeShowerDataComponent, data: {swipeCount: '14'}},
      {path: 'verbrauchsdaten/6', component: EingabeStepComponent, data: {swipeCount: '15'}},
      {path: 'verbrauchsdaten/7', component: EingabeStepComponent, data: {swipeCount: '16'}},
      {path: 'verbrauchsdaten/8', component: EingabeStepComponent, data: {swipeCount: '17'}},

      {path: 'wasserbereitung/1', component: EingabeStepComponent, data: {swipeCount: '20'}},
      {path: 'wasserbereitung/2', component: EingabeStepComponent, data: {swipeCount: '21'}},

      {path: 'geraetedaten/1', component: EingabeStepComponent, data: {swipeCount: '30'}},
      {path: 'geraetedaten/2', component: EingabeStepComponent, data: {swipeCount: '31'}},
      {path: 'geraetedaten/3', component: EingabeStepComponent, data: {swipeCount: '32'}},

      { path: 'ausstieg', component: EingabeAusstiegComponent, data: {swipeCount: '40', ignoreInNav: true, isDeadEnd: true}},

      { path: '', redirectTo: 'basisdaten/1', pathMatch: 'full' },
    ]},

    // result page
    {path: 'ergebnis', component: StepChapterComponent, children: [
      {path: 'auswertung', component: ErgebnisComponent, data: {swipeCount: '50'}},

      { path: '', redirectTo: 'auswertung', pathMatch: 'full' },

    ]},

  ]},


  {path: ':portalId', redirectTo: PortalService.defaultPortal + '/warmwassercheck', pathMatch: 'full'},
  {path: 'warmwassercheck/', redirectTo: PortalService.defaultPortal + '/warmwassercheck', pathMatch: 'full'},
  {path: '', redirectTo: PortalService.defaultPortal + '/warmwassercheck', pathMatch: 'full'},
  {path: '**', pathMatch: 'full', component: AdvisorPagenotfoundComponent, data: {advisor: 'warmwassercheck'}}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    anchorScrolling: 'enabled',
    scrollOffset: [0, 150],
    paramsInheritanceStrategy: 'always'
})],
  exports: [RouterModule]
})
export class WarmwassercheckRoutingModule { }
